import React, { useEffect } from "react";
import { navigate } from "gatsby";
import Helmet from "react-helmet";
import { Container, Grid } from "@material-ui/core";
import { observer, inject } from "mobx-react";
import LoginForm from "../molecules/forms/LoginForm";
import SEO from "../molecules/hidden/SEO";
import { buildDate } from "../store/initial/versioning.json";
import ShortCodeSearch from "../molecules/display/ShortCodeSearch";

const Index = inject("store")(
  observer(
    ({
      store: {
        ui: { signedIn },
        browser: {
          browserLocation: { origin, search }
        }
      }
    }) => {
      useEffect(() => {
        if (signedIn) {
          navigate("/your-pawns");
        }
      }, [signedIn]);
      return (
        <div className="flexCenter">
          <SEO name="Home" />
          <Helmet>
            <link rel="stylesheet" href="/css/index.css" />
            {origin && <link rel="stylesheet" href={`/css/index.${buildDate}.css`} />}
          </Helmet>
          <Container>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={12} md={6}>
                <div />
              </Grid>
              {!signedIn && (
                <Grid item xs={12} md={6}>
                  <LoginForm />
                </Grid>
              )}
              <Grid item xs={12} md={6}>
                <div />
              </Grid>
              <Grid item xs={12} md={6}>
                <ShortCodeSearch />
              </Grid>
            </Grid>
          </Container>
        </div>
      );
    }
  )
);

export default Index;
